import { render } from "./TermAndPolicy.vue?vue&type=template&id=a9c78390"
import script from "./TermAndPolicy.vue?vue&type=script&lang=js"
export * from "./TermAndPolicy.vue?vue&type=script&lang=js"

import "./TermAndPolicy.vue?vue&type=style&index=0&id=a9c78390&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__